import { render, staticRenderFns } from "./LightweightReminder.vue?vue&type=template&id=0b1bbff9&scoped=true"
import script from "./LightweightReminder.vue?vue&type=script&lang=js"
export * from "./LightweightReminder.vue?vue&type=script&lang=js"
import style0 from "./LightweightReminder.vue?vue&type=style&index=0&id=0b1bbff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1bbff9",
  null
  
)

export default component.exports